import { render } from "./FunctionsCatalogConfiguratorTab.vue?vue&type=template&id=1872585e&scoped=true&ts=true"
import script from "./FunctionsCatalogConfiguratorTab.vue?vue&type=script&lang=ts"
export * from "./FunctionsCatalogConfiguratorTab.vue?vue&type=script&lang=ts"

import "./FunctionsCatalogConfiguratorTab.vue?vue&type=style&index=0&id=1872585e&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1872585e"]])

export default __exports__